import UserPosts from './UserPosts';

export default UserPosts;
